<template>
  <div class="integrations-container">
    <ul class="cards-grid">
      <IntegrationCard
        v-for="integration in sortedIntegrations"
        :key="integration.name"
        :integration="integration"
        @toggle="toggleIntegration"
        @request-enable="handleRequestEnable"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue';

import { useTrack, TrackEvents } from '@/composables/useTrack';
import { useToast } from '@/composables/useToast';
import { useIntegrationStore } from '@/modules/integrations/store/useIntegrationStore';
import { storeToRefs } from 'pinia';
import { paragon } from '@useparagon/connect';
import IntegrationCard from './IntegrationCard.vue';

const { track } = useTrack();
const { success } = useToast();

const integrationStore = useIntegrationStore();
const { integration_token, integration_project_id, sortedIntegrations } = storeToRefs(integrationStore);

onMounted(() => integrationStore.fetchIntegrations());

watch(integration_token, newToken => paragon.authenticate(integration_project_id.value ?? '', newToken ?? ''));

const toggleIntegration = async (name: string) => {
  await paragon.authenticate(integration_project_id.value ?? '', integration_token.value ?? '');
  paragon.connect(name.toLowerCase(), { onInstall: handleSuccess, onUninstall: handleSuccess });
};

const handleRequestEnable = (name: string) => {
  track(TrackEvents.INTEGRATIONS_SETUP_REQUESTED, { app: name });
  success(`Thanks for your interest in ${name}! We've recorded your request and will follow up with pricing and availability.`, {
    title: 'Integration Request Submitted',
  });
};

const handleSuccess = () => {
  integrationStore.fetchIntegrations(true);
};
</script>

<style scoped>
.integrations-container {
  @apply py-8;
}
.cards-grid {
  @apply grid gap-6 mt-4;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}
</style>
